import { render, staticRenderFns } from "./FreshChatTable.vue?vue&type=template&id=6bb53ad6&scoped=true"
import script from "./FreshChatTable.vue?vue&type=script&lang=js"
export * from "./FreshChatTable.vue?vue&type=script&lang=js"
import style0 from "./FreshChatTable.vue?vue&type=style&index=0&id=6bb53ad6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb53ad6",
  null
  
)

export default component.exports